module.exports = __webpack_public_path__ + "img/v8.4b8d7ce1.png";